import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { DeviceEntity } from './device.entity'
import type { SendPushNotification } from './send-push-notification.dto'

export class DevicesRepository extends BaseRepository<DeviceEntity> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.userApiUrl + '/' + 'devices', token, cache)
    }

    async refreshToken(deviceId: string) {
        const url = this.config.userApiUrl + '/devices/' + deviceId + '/reset?token=' + this.resolvedToken
        const { json, statusCode, message } = await this.request.get(url)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async requestLoginByDevice(deviceId: string) {
        try {
            // usando fetch para receber o cookie de autenticação
            const url = this.config.userApiUrl + '/auth2/cookie/request/' + deviceId + '?token=' + this.resolvedToken
            const req = await fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
            const json = await req.json()
            return json
        } catch (error) {
            throw error
        }
    }

    async requestJWTTokenByDevice(companyId: string) {
        try {
            // usando fetch para receber o cookie de autenticação
            const url = this.config.userApiUrl + '/auth2/cookie/' + companyId
            const req = await fetch(url, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
            const json = await req.json()
            return json
        } catch (error) {
            throw error
        }
    }

    async sendPushNotification(dto: SendPushNotification) {
        const url = this.config.userApiUrl + '/devices/push?token=' + this.resolvedToken
        const { json, statusCode, message } = await this.request.post(url, dto)
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
